import React from "react";
import { makeStyles } from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles({
  container: {
    position: "fixed",
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1101,
    backgroundColor: "rgba(255,255,255,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  spinner: {
    color: "rgba(0,0,0,0.54)"
  }
});

const Spinner = React.memo(function() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CircularProgress
        classes={{ colorPrimary: classes.spinner }}
        size={256}
      />
    </div>
  );
});

export default Spinner;
